import React, { useState, useRef, useEffect } from "react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  TypingIndicator
} from "@chatscope/chat-ui-kit-react";
import api from "../../api/axios";

const ChatIA = ({ businessId }) => {
  const [messages, setMessages] = useState([
    {
      message: "¡Hola! Soy tu asistente virtual 🤖, ¿en qué te puedo ayudar?",
      sender: "IA",
      direction: "incoming"
    }
  ]);
  const [typing, setTyping] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  const messageListRef = useRef();

  // Scroll automático al último mensaje
  useEffect(() => {
    if (messageListRef.current) {
      messageListRef.current.scrollToBottom();
    }
  }, [messages]);

  const handleSend = async (userMessage) => {
    const newMessage = {
      message: userMessage,
      sender: "user",
      direction: "outgoing"
    };
    const newMessages = [...messages, newMessage];
    setMessages(newMessages);
    setTyping(true);

    try {
      const res = await api.post("/ai-agent/catalog", {
        business_id: businessId,
        message: userMessage,
        session_id: sessionId // mandar sessionId si ya existe
      });

console.log("Respuesta back (raw):", res.data);
console.log("Reply recibido en front:", res.data?.reply);
console.log("SessionId recibido:", res.data?.sessionId);
      const botReply = res.data?.reply || "No pude procesar tu consulta 😅";

      setMessages([
        ...newMessages,
        {
          message: botReply,
          sender: "IA",
          direction: "incoming"
        }
      ]);

      if (res.data?.sessionId) {
        setSessionId(res.data.sessionId); // guardar para siguientes mensajes
      }
    } catch (err) {
      setMessages([
        ...newMessages,
        {
          message: "Hubo un error al conectar con el asistente 🚨",
          sender: "IA",
          direction: "incoming"
        }
      ]);
    } finally {
      setTyping(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "350px",
        height: "500px",
        zIndex: 1000
      }}
    >
      <MainContainer>
        <ChatContainer>
          <MessageList
            ref={messageListRef}
            typingIndicator={typing ? <TypingIndicator content="Escribiendo..." /> : null}
          >
            {messages.map((msg, i) => (
              <Message key={i} model={msg} />
            ))}
          </MessageList>
          <MessageInput placeholder="Escribí tu consulta..." onSend={handleSend} />
        </ChatContainer>
      </MainContainer>
    </div>
  );
};

export default ChatIA;
